import echarts from "echarts";
import Fruit from "./fruit.vue";
import Dropper from "./Dropper.vue";
const oneDay = 1000 * 60 * 60 * 24 * 1;

export default {
  components: { Fruit, Dropper },

  data() {
    const isWebview = sessionStorage.getItem("isWebview");

    return {
      isWebview: Boolean(isWebview),
      index: 0,
      kind: 0,
      ishow: false,
      ischange: false,
      isreferesh: false,
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "",
      dname: localStorage.getItem("dname") ? localStorage.getItem("dname") : "", // 设备名称
      monlist: [],
      istart: false,
      iend: false,
      itype: 1,
      sminDate: new Date(2020, 0, 1),
      sminDate2: new Date(2020, 0, 1),
      smaxDate: new Date(),
      eminDate: new Date(2020, 0, 1),
      emaxDate: new Date(),
      time1: this.$setime(new Date(), 2),
      time2: this.$setime(new Date(), 2),
      chart: "",
      devicelist: "", // 所有设备列表
      choselist: "", // 选中的设备
      des: "", // 选中设备索引split
      retime: "", // 最后更新时间
      relist: "", // 属性列表
      nowre: "", // 当前选择的属性
      thlist: "",
      msg: "",
      option: "",
      xoption: "", // x轴参数
      voption: [], // 数据参数
      xoption2: "", // x轴参数 雨量
      voption2: [], // 数据参数 雨量
      xoption3: [], // x轴数据 日最大伸缩量
      voption3: [], // y轴数据参数 日最大伸缩量
      rainType: [
        {
          label: "年",
          id: "Year",
          check: true
        },
        {
          label: "月",
          id: "Month",
          check: false
        },
        {
          label: "日",
          id: "Day",
          check: false
        },
        {
          label: "时",
          id: "Hour",
          check: false
        }
      ],
      attrId: null, // 雨量传感器id
      max: null,
      min: null,
      days: [
        {
          label: "7天",
          sT: this.$setime(new Date() - oneDay * 6, 2),
          eT: this.$setime(new Date(), 2),
          check: false,
          type: "button"
        },
        {
          label: "15天",
          sT: this.$setime(new Date() - oneDay * 14, 2),
          eT: this.$setime(new Date(), 2),
          check: false,
          type: "button"
        },
        {
          label: "30天",
          sT: this.$setime(new Date() - oneDay * 29, 2),
          eT: this.$setime(new Date(), 2),
          check: false,
          type: "button"
        }
      ],
      minChooseMonthDate: new Date(2020, 0, 1),
      maxChooseMonthDate: new Date(),
      showMonthPicker: false,
      chooseMouth: "",
      yearMonthPickerCurrentDate: new Date(),
      hasFruit: false,
      fruitData: [0, 0, 0, 0, 0, 0, 0],
      hasDropper: false,
      DropperData: [0, 0, 0, 0, 0, 0, 0]
    };
  },

  mounted() {
    // 创建图表
    setTimeout(async () => {
      // this.getDate()
      await this.getDeviceList();
      // 默认当前月
      await this.onHandleMonthConfirm(new Date(), true);

      // 默认 7天 先
      await this.handleClickDays(0);
      // 请求设备的基本数据 传感器的数据
      // await this.getLiveDetail(this.choselist.no)
      // 从所有传感器中查询是否有果径
      await this.getFruitDevice();
      // 从所有传感器中查询是否有滴管
      this.getDropperDevice();
    }, 10);
  },

  methods: {
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },

    handleChooseMonth() {
      this.showMonthPicker = true;
    },

    // num = 1 2 3 4 5 6 7 8 9 10 11 12 月
    renderMonth(year, month) {
      const date = new Date();

      let mon = month;
      if (mon === undefined) {
        mon = date.getMonth() + 1;
      }

      // 默认查询当前一个月的
      // 需要计算当前月是有多少天
      year = year || date.getFullYear();
      let days = null;

      let isRun = false;
      // 如果是闰年  2月份是 28天
      if ((year % 4 == 0 && year % 100 !== 0) || year % 400 == 0) {
        isRun = true;
      } else {
        isRun = false;
      }

      if ((mon <= 7 && mon % 2 === 1) || (mon > 7 && mon % 2 === 0)) {
        days = 31;
      } else {
        days = 30;
      }

      if (mon === 2 && isRun) {
        days = 29;
      } else if (mon === 2) {
        days = 28;
      }

      // 判断选择的月份是否是当前月
      // 如果是当前月 时间则为当前日期

      const sDate = `${year}-${mon.toString().padStart(2, "0")}-01`;

      let eDate = `${year}-${mon}-${days}`;

      if (year === date.getFullYear() && mon === date.getMonth() + 1) {
        eDate = new Date();
      } else {
        eDate = new Date(eDate.replace(/-/g, "/"));
      }

      this.time1 = sDate;
      this.time2 = this.$setime(eDate, 2);

      // 在获取到传感器数据之后设置相关的时间
      // var st = nt - 86400000 * 7
      // var at = new Date(st)
      this.sminDate = new Date(sDate.replace(/-/g, "/"));

      this.eminDate = new Date();
    },

    async onHandleMonthConfirm(val, notReq) {
      const date = new Date(val);
      const year = date.getFullYear();
      const mon = date.getMonth() + 1;

      this.renderMonth(year, mon);
      this.chooseMouth = `${year}年${mon}月`;
      this.days.map(item => (item.check = false));
      this.onHandleMonthCancel();
    },

    onHandleMonthCancel() {
      this.showMonthPicker = false;
    },

    // 绘图
    async drawGraph(id, xoption, voption) {
      console.log("xoption:", xoption);
      console.log("voption:", voption);

      try {
        // 判断选中了一个 并且是水势
        const checkList = this.relist.filter(o => o.isel);

        if (checkList.length === 1 && checkList[0].oriName == "土壤张力") {
          await this.$api
            .getHold({
              channelNo: checkList[0].channelNo,
              no: this.no
            })
            .then(res => {
              const { lowerLimit, uperLimit } = res;
              voption.map(item => {
                item.markArea = {
                  data: [
                    [
                      {
                        yAxis: 0,
                        itemStyle: {
                          color: "#ecf5ff"
                        }
                      },
                      {
                        yAxis: lowerLimit,
                        itemStyle: {
                          color: "#ecf5ff"
                        }
                      }
                    ],
                    [
                      {
                        yAxis: lowerLimit,
                        itemStyle: {
                          color: "#f0f9eb"
                        }
                      },
                      {
                        yAxis: uperLimit,
                        itemStyle: {
                          color: "#f0f9eb"
                        }
                      }
                    ],
                    [
                      {
                        yAxis: uperLimit,
                        itemStyle: {
                          color: "#fef0f0"
                        }
                      },
                      {
                        yAxis: this.max,
                        itemStyle: {
                          color: "#fef0f0"
                        }
                      }
                    ]
                  ]
                };
              });
            });
        }

        // 绘图方法
        this.chart = echarts.init(document.getElementById(id));
        // 皮肤添加同一般使用方式
        this.chart.showLoading();
        // 返回到data中

        const yAxisObj = {
          type: "value",
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#f5f5f5"],
              width: 0.5,
              type: "solid"
            }
          }
        };

        const list = this.thlist;
        // 按日期分组
        const group = [];

        list.map(item => {
          const date = item.gatherDate.split(" ")[0];
          // 所有的数据都是共用一个日期，所以直接找第一条即可
          const tar = item.data[0];
          // 按日期分组
          const tarIndex = group.findIndex(o => o.date === date);
          if (tarIndex > -1) {
            group[tarIndex].data = group[tarIndex].data.concat(tar.value);
            group[tarIndex].datelist.push(item.gatherDate);
          } else {
            group.push({
              date,
              data: [tar.value],
              datelist: [item.gatherDate]
            });
          }
        });

        // 标注
        let markArea = {
          itemStyle: {
            color: "#e1e1e1" // 背景色
          },
          data: group
            .map((item, index) => {
              // 模2  就是间隔开
              if (index % 2 === 1) {
                return [
                  { xAxis: item.datelist[0] },
                  { xAxis: item.datelist[item.datelist.length - 1] }
                ];
              }
            })
            .filter(o => o)
        };

        var _this = this;
        const options = {
          tooltip: {
            trigger: "axis"
          },
          grid: {
            top: "12%",
            left: "2%",
            right: "10%",
            bottom: "14%",
            containLabel: true
          },
          toolbox: {
            feature: {}
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              xAxisIndex: [0],
              left: "6.5%",
              bottom: 0,
              start: 0,
              end: 100 // 初始化滚动条
            }
          ],
          xAxis: {
            type: "category",
            data: xoption,
            boundaryGap: false,
            axisLabel: {
              length: 3,
              formatter: function(value) {
                if (value.indexOf(" ") > -1) {
                  var ges = value.split(" ");
                  var qian = ges[0].split("-");
                  var hou = ges[1].split(":");
                  var non = ges[0] + "\n" + ges[1];
                  return non;
                }
              }
            }
          },
          yAxis: [],
          series: voption
          // yAxisIndex: 1
        };

        options.yAxis.push(yAxisObj);
        let yAxisIndex = 1;
        const color = ["#2ec7c9", "#2337d9"];

        voption.map((item, index) => {
          const hasOther = this.relist.find(
            o => o.index === "43" && o.isel && o.name !== item.name
          );
          const isel = this.relist.find(o => o.name === item.name && o.isel);
          // 43 是 茎干
          if (item.index == "43" && isel) {
            console.log("应该进来了才对啊");
            const data = [...item.data];

            const fillNull = data.filter(o => o !== "null" && o);
            fillNull.sort((a, b) => a - b);
            options.yAxis.push({
              ...yAxisObj,
              min: fillNull[0],
              max: fillNull[fillNull.length - 1],
              name: isel ? item.name : "",
              offset: yAxisIndex > 1 && hasOther ? 45 : 0
            });
            item.yAxisIndex = yAxisIndex++;
            item.markPoint = {
              label: {
                show: true,
                position: "top",
                distance: 7,
                offset: [1, 1],
                formatter: "{b}:{c}",
                color: color[yAxisIndex - 1]
              },
              symbol: "circle",
              symbolSize: 10,
              symbolOffset: [0, 0],
              data: [
                { type: "min", name: "最小值", color: color[yAxisIndex - 1] },
                { type: "max", name: "最大值", color: color[yAxisIndex - 1] }
              ]
            };
            item.lineStyle = {
              color: color[yAxisIndex - 1]
            };
          }

          // 80 是 重量
          if (item.index == "80" && isel) {
            const data = [...item.data];
            const fillNull = data.filter(o => o !== "null" && o);
            fillNull.sort((a, b) => Number(a) - Number(b));

            console.log("80 是 重量 data:", data);

            console.log("最小值:", fillNull[0]);
            console.log("最小值:", fillNull[fillNull.length - 1]);

            yAxisObj.min = fillNull[0];
            yAxisObj.max = fillNull[fillNull.length - 1];

            item.markPoint = {
              label: {
                show: true,
                position: "top",
                distance: 7,
                offset: [1, 1],
                formatter: "{b}:{c}"
              },
              symbol: "circle",
              symbolSize: 10,
              symbolOffset: [0, 0],
              data: [
                { type: "min", name: "最小值" },
                { type: "max", name: "最大值" }
              ]
            };
          }

          // 滴管的曲线颜色
          if (item.index === "59" && this.relist[index].isel) {
            item.lineStyle = { color: "#2337d9" };

            // if (item.oriName !== '压力')
            // 在这里添加标注
            // 将数据 list 中的数据进行遍历，某一段值不为0  连续的 则标注出来
            const markData = [];
            // 把滴管压力的数据和日期全部取出来  { value,  日期 }
            //
            let start = true;
            let obj = {};
            const allData = [];
            list.map((_item, index) => {
              const x = _item.gatherDate;
              let v = 0;
              const _o = { x };
              if (_item.data && _item.data.length) {
                const tar = _item.data.find(o => o.oriName === "压力");

                if (tar && tar.hasOwnProperty("value")) {
                  v = Number(tar.value);
                  _o.v = v;
                }
              }

              allData.push(_o);

              // 值大于 0  且 开始的标记
              if (v > 20 && start) {
                obj.sX = x;
                start = false;
              } else if (v < 20 && !start) {
                // 值等于0 是 结束的标记 说明一段有值的数据持续完成
                obj.eX = x;
                start = true;
                markData.push(obj);
                obj = {};
              } else if (!start && index === list.length - 1) {
                obj.eX = x;
                start = true;
                markData.push(obj);
                obj = {};
              }
            });

            const temp = 1000;
            const s_unit = 1 * temp;
            const m_unit = 60 * s_unit;
            const h_unit = 60 * m_unit;
            const d_unit = 24 * h_unit;

            const markAreaData = [];

            // 计算两个时间中有多少分钟
            markData.map((o, i) => {
              const sX = o.sX.replaceAll("-", "/");
              const eX = o.eX.replaceAll("-", "/");

              const sT = new Date(sX).getTime();
              const eT = new Date(eX).getTime();

              const rT = eT - sT;

              o.rT = rT;

              const n = {
                d: 0,
                h: 0,
                m: 0,
                s: 0
              };

              n.d = Math.floor(rT / d_unit);
              n.h = Math.floor((rT - n.d * d_unit) / h_unit);
              n.m = Math.floor((rT - n.d * d_unit - n.h * h_unit) / m_unit);
              n.s = Math.floor(
                (rT - n.d * d_unit - n.h * h_unit - n.m * m_unit) / s_unit
              );

              o.txt = "";
              ["d", "h", "m"].map(k => {
                if (n[k] > 0) {
                  o.txt = o.txt + String(n[k]) + k;
                }
              });

              markAreaData.push([
                {
                  name: o.txt,
                  xAxis: o.sX
                },
                {
                  xAxis: o.eX
                }
              ]);
            });

            markArea = {
              itemStyle: {
                color: "pink" // 背景色
              },
              data: markAreaData
            };
          }

          item.markArea = markArea;
        });

        console.log("voption:", voption);
        console.log("options:", options);

        this.chart.setOption(options, true);
        this.chart.hideLoading();
      } catch (e) {
        console.error(e);
      }
    },

    // 时间快捷选择
    async handleClickDays(ind) {
      this.chooseMouth = "";
      this.days.map((item, index) => {
        if (index === ind) {
          item.check = true;
        } else {
          item.check = false;
        }
      });
      const { sT, eT } = this.days[ind];
      this.time1 = sT;
      this.time2 = eT;
      await this.getLiveDetail(this?.choselist?.no);
    },

    // 时间选择
    setTime(i) {
      if (i == 1) {
        this.istart = true;
      } else if (i == 2) {
        this.iend = true;
      }
      this.itype = i;
      this.$refs.datepicker.setFrom(i);
    },

    setSed(data, type) {
      this.days.find(o => (o.check = false));

      if (!this.$isblank(data)) {
        var i = this.itype;
        if (i == 1) {
          this.time1 = data;
        } else if (i == 2) {
          this.time2 = data;
        }
        this.getLiveDetail(this.choselist.no);
      }

      // 点击的是开始时间
      if (type === 1) {
        this.chooseMouth = null;
      }

      this.istart = false;
      this.iend = false;
    },

    // 设备选择
    showChangeTrend() {
      if (this.isWebview) return;
      const isView = sessionStorage.getItem("isView");
      if (isView) return;

      this.ishow = true;
      this.ischange = true;
    },

    // 设备点击
    onConfirm(value, index) {
      this.retime = "";
      this.relist = "";
      this.nowre = "";
      this.ishow = false;
      this.ischange = false;
      this.dname = value;
      localStorage.setItem("dname", value);
      var devicelist = this.devicelist;
      var choselist = "";
      var des = this.des;
      if (!this.$isblank(devicelist)) {
        if (this.$isblank(this.dname)) {
          des = 0;
        } else {
          for (var i = 0; i < devicelist.length; i++) {
            if (devicelist[i].deviceName == value) {
              // .log(devicelist[i].deviceName, value);
              des = i;
              this.no = devicelist[i].no;
            }
          }
        }
        choselist = devicelist[des];
        localStorage.setItem("no", choselist.no);
        this.des = des;
        this.no = choselist.no;
        this.choselist = choselist;
        this.getLiveDetail(choselist.no);
      }
    },

    // 设备选择取消
    onCancel(e) {
      this.ischange = false;
      this.ishow = false;
    },

    // 时间更新
    doReferesh() {
      this.isreferesh = true;
      this.getLiveDetail(this.no || localStorage.getItem("no"));
    },

    // 点击属性
    setKind(i) {
      console.error("点击传感器：", i, this.relist);

      this.kind = i;
      var relist = this.relist;
      const arr = [...relist];
      this.setOption(this.thlist, i);

      if (relist[i].isel) {
        this.nowre = relist[i];
      } else {
        const target = arr.reverse().find(o => o.isel);
        if (target) {
          this.nowre = target;
        } else {
          this.nowre = {};
        }
      }

      console.log("nowre:", this.nowre);
    },

    // 查询设备列表
    async getDeviceList(num) {
      this.$toast.loading({
        message: this.$t("live.read_loading"),
        forbidClick: true,
        duration: 0
      });
      var _this = this;

      const deviceType = sessionStorage.getItem("deviceType");

      await this.$api
        .getDeviceList({ type: deviceType || 2 })
        .then(res => {
          _this.$toast.clear();
          if (res.errcode == 0) {
            var des = _this.des;
            var dname = _this.dname;
            var devicelist = res.data;
            var choselist = "";
            var monlist = new Array();
            if (!_this.$isblank(devicelist)) {
              if (_this.$isblank(dname)) {
                des = 0;
              } else {
                for (var i = 0; i < devicelist.length; i++) {
                  if (devicelist[i].deviceName == dname) {
                    des = i;
                  }
                }
              }
              for (var i = 0; i < devicelist.length; i++) {
                // monlist.push(devicelist[i].deviceName+"("+devicelist[i].no+")");
                monlist.push(devicelist[i].deviceName);
              }

              choselist = devicelist[des];

              console.log("choselistchoselist:", choselist, des);

              _this.choselist = choselist;
              _this.devicelist = devicelist;
              _this.des = des;
              _this.monlist = monlist;

              localStorage.setItem("no", choselist.no);
              localStorage.setItem("dname", choselist.deviceName);

              _this.$refs.pageToast.type = 0;
            } else {
              // 没有设备列表
              _this.$refs.pageToast.type = 1;
            }
          } else {
            // 其他异常
            _this.$toast.clear();
            _this.$toast(_this.$t("common.nodata"));
          }
        })
        .catch(err => {
          // 其他异常
          _this.$toast.clear();
          // _this.$toast("连接超时");
        });
    },

    // 读取设备基本信息
    async getLiveDetail(no) {
      console.log("请求数据：", this.time1, this.time2);

      var _this = this;
      _this.relist = [];
      _this.thlist = [];
      _this.xoption = "";
      _this.voption = [];

      var nt = new Date().valueOf();
      this.$toast.loading({
        message: this.$t("trend.data_loading"),
        forbidClick: true,
        duration: 0
      });
      if (_this.time1 > _this.time2) {
        this.$toast(this.$t("export.tis_time"));
        return false;
      }

      // 如果天数上大于7天的，则拆分为多个7天的小组 进行请求 然后拼接
      let st = new Date(_this.time1).getTime();
      const et = new Date(_this.time2).getTime();
      const spliceDays = [];

      // 开始时间加上7天时间， 如果小于结束时间
      while (st + oneDay * 7 < et) {
        spliceDays.push({
          sT: this.$setime(st, 2),
          // 7天后的日期
          eT: this.$setime(st + oneDay * 7, 2)
        });
        // 加到7天的下一天 就是第8天
        st += oneDay * 8;
      }

      spliceDays.push({
        sT: this.$setime(st, 2),
        eT: this.$setime(et, 2)
      });

      console.log("spliceDays:", spliceDays);

      const reqList = [];

      spliceDays.map(item => {
        reqList.push(
          this.$api.getLiveList({
            no,
            startDate: item.sT + " 00:00:00",
            endDate: item.eT + " 23:59:59"
          })
        );
      });

      let dataList = [];

      this.eminDate = new Date(spliceDays[0].sT);

      // //==================================
      // reqList = []
      // reqList.push(
      //   this.$api.getLiveList({
      //     no,
      //     startDate: '2023-11-03 00:00:00',
      //     endDate: '2023-11-03 05:20:00'
      //   })
      // );
      // //==================================

      console.log("reqList:", reqList);

      await Promise.all(reqList)
        .then(res => {
          _this.$toast.clear();

          console.log("res:", res);

          res.map(item => {
            if (!this.$isblank(item.list)) {
              dataList = dataList.concat(item.list);
            }
          });

          if (!_this.$isblank(dataList)) {
            var list = [...dataList];
            _this.thlist = [...list]; // 所有的统计数据
            _this.retime = list[list.length - 1].gatherDate;
            var relist = list[list.length - 1].data;

            for (let i = 0; i < relist.length; i++) {
              relist[i].isel = false;
            }

            // 判断传感器中是否有雨量传感器  有的话则请求雨量
            console.log("relist:", relist);
            const target = relist.find(
              o => (o.oriName || o.name).indexOf("雨量") > -1
            );
            if (target) {
              this.attrId = target.id;
              this.getRainStatic(0);
            }

            _this.relist = relist;
            _this.nowre = _this.relist[0];
            _this.isreferesh = false;
            _this.kind = 0;
            _this.xoption = "";
            _this.voption = "";
            _this.setOption(list, 0);

            _this.$refs.pageToast.type = 0;
          } else {
            _this.thlist = []; // 所有的统计数据
            _this.$refs.pageToast.type = 1;

            this.drawGraph("echarts", [], []);
          }
        })
        .catch(err => {
          console.error("查询统计:", err);
          // 其他异常
          _this.$toast.clear();
          _this.$toast(_this.$t("common.timeout"));
        });
    },

    /**
     * @desc 设置折线图数据
     * @param {Array} list  所有的统计数据
     * @param {Number} index 所中传感器的下标
     */
    setOption(list, index) {
      // 选中状态改变
      const targetSensor = this.relist[index];
      // 替换arr 对应的这条数据
      this.relist.splice(index, 1);
      targetSensor.isel = !targetSensor.isel;
      this.relist.splice(index, 0, targetSensor);

      // 组合折线图所需的数据
      var xoption = new Array();
      var opts = new Array();

      let maxDataLengthIndex = null;
      let maxDataLength = 0;

      // 去 data 最长的 那条，因为是最新的数据
      list.map((item, index) => {
        if (item.data && item.data.length > maxDataLength) {
          maxDataLength = item.data.length;
          maxDataLengthIndex = index;
        }
      });

      for (var i = 0; i < list.length; i++) {
        // 取最后一条数据
        var nowre = list[list.length - 1].data;
        // 设置x轴数据
        xoption.push(list[i].gatherDate.toString());

        // 这里只拿到所有统计数据中的第一条传感器数据列表
        for (var a = 0; a < nowre.length; a++) {
          if (i == 0) {
            var se = {
              index: nowre[a].index,
              name: nowre[a].name,
              type: "line",
              // stack: "总量",
              data: "",
              symbolSize: 0.3, // 拐点大小
              smooth: true,
              lineStyle: {
                width: 1
              }
            };
            opts.push(se);
          }
        }
      }

      console.log("opts:", opts);
      // 组合单个数据
      let max = []; // 取最大值 展示在上面
      let min = [];
      for (let b = 0; b < opts.length; b++) {
        max.push(null);
        min.push(null);
        const {
          isel,
          sensorId,
          channelNo,
          index: reIndex,
          uuid,
          name
        } = this.relist[b];

        // 这里需要确定唯一性 单独使用 sensorId 是不能保证唯一的，需要 sensorId  index channelNo 三者来确定唯一

        const id = this.spliceUniqueId(
          sensorId,
          channelNo,
          reIndex,
          uuid,
          name
        );

        if (isel) {
          const op = new Array();
          for (let i = 0; i < list.length; i++) {
            const nowre = list[i].data;
            const find = nowre?.find?.(
              o =>
                this.spliceUniqueId(
                  o.sensorId,
                  o.channelNo,
                  o.index,
                  o.uuid,
                  o.name
                ) == id
            );

            if (find && !isNaN(Number(find.value))) {
              op.push(find.value);
            } else {
              op.push("");
            }
          }

          console.log("op:", op);

          // 每一个传感器的 data 值
          opts[b].data = op;
          const arr = op.map(o => (o = Number(o))).filter(o => o);
          max[max.length - 1] = Math.max(...arr);
          min[min.length - 1] = Math.min(...arr);
        }
        console.log("this.relist[index]: ", this.relist[index]);
        if (this.relist[index].isel == true) {
          this.max = max[index];
          this.min = min[index];
        } else {
          max = max.filter(o => o);
          min = min.filter(o => o);
          this.max = max[max.length - 1];
          this.min = min[min.length - 1];
        }

        if (!this.max || this.max === -Infinity) {
          this.max = "0.0";
        }

        if (!this.min || this.min === -Infinity) {
          this.min = "0.0";
        }
      }

      this.xoption = xoption;

      this.voption = opts;
      this.drawGraph("echarts", this.xoption, this.voption);

      console.log("1111111:", this.max, this.min);
    },

    spliceUniqueId(key1, key2, key3, key4, key5) {
      return `${key1}_${key2}_${key3}_${key4}_${key5}`;
    },

    // 切换时间线
    handleRainRange(index) {
      const ind = this.rainType.findIndex(o => o.check);
      const obj = this.rainType[ind];
      const obj2 = this.rainType[index];
      obj.check = false;
      obj2.check = true;
      this.$set(this.rainType, ind, obj);
      this.$set(this.rainType, index, obj2);
      // 查询雨量统计
      this.getRainStatic(index);
    },

    // 获取雨量统计
    getRainStatic(index) {
      this.$toast.loading({
        message: this.$t("live.read_loading"),
        forbidClick: true,
        duration: 0
      });

      const target = this.rainType[index];
      this.$api[`rainStatic${target.id}`]({
        page: 1,
        pageSize: 99999,
        attrId: this.attrId,
        // attrId: 3154,
        orderBy: "asc" // "排序，asc/desc"
      })
        .then(res => {
          this.$toast.clear();

          if (res.errcode === 0 && res.list && res.list.length) {
            this.$refs.pageToast2.type = 0;
            const xoption = [];
            const yData = [];
            res.list.map(item => {
              const { year, month, day, hour } = item;
              if (index === 0) xoption.push(year);
              else if (index === 1) xoption.push(`${year}-${month}`);
              else if (index === 2) xoption.push(`${year}-${month}-${day}`);
              else if (index === 3) {
                xoption.push(`${year}-${month}-${day} ${hour}:00:00`);
              }

              yData.push(item.val);
            });

            this.xoption2 = [...xoption];
            this.voption2 = {
              name: "雨量",
              type: "line",
              data: yData,
              symbolSize: 0.3, // 拐点大小
              smooth: true,
              lineStyle: {
                width: 1
              }
            };

            this.drawGraph("rain-echarts", this.xoption2, this.voption2);
          } else {
            this.xoption2 = [];
            this.voption2 = [];
            this.$refs.pageToast2.type = 1;
            // this.drawGraph("rain-echarts", [], []);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    // 查询是否有果径传感器
    async getFruitDevice() {
      // 请求前一天的数据
      // this.time1 = sT
      // this.time2 = eT

      let thlist = JSON.parse(JSON.stringify(this.thlist));
      const sT = this.$setime(new Date(this.time1) - oneDay * 1, 2);
      const eT = this.$setime(new Date(this.time1), 2);

      await this.$api
        .getLiveList({
          no: this.no,
          startDate: sT + " 00:00:00",
          endDate: eT + " 23:59:59"
        })
        .then(res => {
          if (res.errcode === 0) {
            thlist = res.list.concat(thlist);
          } else {
            this.$toast({
              message: `获取果径传感器异常:${res?.errmsg}`
            });
          }
        })
        .catch(err => {
          this.$toast({
            message: `获取果径传感器异常:${res?.errmsg}`
          });
        });

      const fruitServiceDataLsit = [];
      this.relist.map(o => {
        if (o.index === "43" && o.name.indexOf("果径") > -1) {
          fruitServiceDataLsit.push(this.caculationFruitData(thlist, o));
        }
      });

      this.fruitData = [...fruitServiceDataLsit];
    },

    // 计算多个果径的数据
    caculationFruitData(thlist, tar) {
      if (tar) {
        this.hasFruit = true;
        // 拿到所有的统计数据  按日期筛选出果径的数据  取最后的7天数据
        let fruitData = [];
        const yData = [];
        // { date  , value , week }
        thlist.map(o => {
          if (o.data && o.data.length) {
            const t = o.data.find(o => o.name === tar.name);
            if (t) {
              const d = o.gatherDate.split(" ")[0];
              let week = this.$noToChinese(
                new Date(d.replaceAll("-", "/")).getDay()
              );
              if (week === "零" || week === "") {
                week = "日";
              }
              const time = new Date(
                o.gatherDate.replaceAll("-", "/")
              ).getTime();

              yData.push({
                name: time,
                value: [time, t.value]
              });

              const obj = {
                week,
                date: d,
                max: t.value, // 果径的最大值
                grow: 0
              };

              const ind = fruitData.findIndex(k => k.date === obj.date);
              if (ind === -1) {
                fruitData.push(obj);
              } else {
                fruitData[ind].max = Math.max(obj.max, t.value);
              }
            }
          }
        });

        fruitData.map((item, index) => {
          const none = ["null", "NaN", null, NaN];
          if (none.includes(item.max)) {
            item.max = "";
            item.grow = "";
          } else {
            if (index !== 0) {
              item.grow = (item.max - fruitData[index - 1].max).toFixed(2);
            }
          }
        });

        // 删除掉第一条的，第一条的数据只是为了计算一周时间内  第一天的 grow 成长值
        fruitData.shift();

        // 如果长度大于7 取7条 如果长度小于7 取全部
        if (fruitData > 7) {
          fruitData = {
            data: [...fruitData.reverse().slice(0, 7)],
            yData
          };
        } else {
          fruitData = { data: [...fruitData], yData, name: tar.name };
        }

        return fruitData;
      }
    },

    // 查询是否有滴管压力传感器
    async getDropperDevice() {
      const tar = this.relist.find(
        o => o.index === "59" && o.oriName === "压力"
      );
      if (tar) {
        const dropperData = [];
        this.hasDropper = true;
        try {
          this.thlist.map((o, i) => {
            if (o.data && o.data.length) {
              const t = o.data.find(o => o.oriName === "压力");
              if (t) {
                // o.gatherDate.indexOf("2022-11-27") > -1 &&
                //   console.log("123:", t.value, o.gatherDate);
                const d = o.gatherDate.split(" ")[0];
                let week = this.$noToChinese(
                  new Date(d.replaceAll("-", "/")).getDay()
                );
                if (week === "零" || week === "") {
                  week = "日";
                }
                const time = new Date(
                  o.gatherDate.replaceAll("-", "/")
                ).getTime();

                const obj = {
                  date: d,
                  time,
                  mSecond: 0,
                  week,
                  sDate: d.substr(5),
                  start: true,
                  sTime: time
                };

                const ind = dropperData.findIndex(o => o.date === obj.date);

                if (ind > -1) {
                  // 如果 > 20  则计算进去上一次的 time
                  if (Number(t.value) > 20 && dropperData[ind].start) {
                    dropperData[ind].sTime = time;
                    dropperData[ind].start = false;
                  } else if (Number(t.value) < 20 && !dropperData[ind].start) {
                    dropperData[ind].mSecond += time - dropperData[ind].sTime;
                    dropperData[ind].sTime = time;
                    dropperData[ind].start = true;
                  }
                } else {
                  if (Number(t.value) > 20) {
                    obj.start = false;
                  }
                  dropperData.push(obj);
                }
              }
            }
          });

          console.log("dropperData:", dropperData);

          // 如果长度大于7 取7条 如果长度小于7 取全部
          if (dropperData > 7) {
            this.dropperData = [...dropperData.reverse().slice(0, 7)];
          } else {
            this.dropperData = [...dropperData];
          }

          this.dropperData.map(o => {
            o.duration = this.caculationTime(o.mSecond);
          });

          console.log("dropperData:", this.dropperData);
        } catch (e) {
          console.error(e);
        }
      }
    },

    caculationTime(time) {
      const temp = 1000;
      const s_unit = 1 * temp;
      const m_unit = 60 * s_unit;
      const h_unit = 60 * m_unit;
      const d_unit = 24 * h_unit;

      const n = {
        // d: 0,
        h: 0,
        m: 0,
        s: 0
      };

      // n.d = Math.floor(time / d_unit);
      n.h = Math.floor(time / h_unit);
      n.m = Math.floor((time - n.h * h_unit) / m_unit);
      n.s = Math.floor((time - n.h * h_unit - n.m * m_unit) / s_unit);

      let txt = "";
      ["h", "m"].map(k => {
        txt = txt + String(n[k]) + k;
      });

      return txt;
    }
  }
};
